/**
 * Что кладётся в сохранённый вид сверх самих настроек раздела.
 *
 * Три вещи, и все три — не настройки, а приметы самого вида:
 *  • раздел, чтобы вид открылся тем разделом, в котором его сохранили;
 *  • центр карты из РАМКИ, а не из состояния: человек сохраняет то, на что
 *    смотрит, а состояние отстаёт на пан, который ещё не доехал до URL;
 *  • смещение даты, чтобы «мой завтрашний прогноз» оставался завтрашним.
 *
 * Отдельным модулем, потому что оба раздела зовут это одинаково, а разъехаться
 * им нельзя: вид «Карт» без смещения открывался бы снимком, вид «Моделей» без
 * пометки раздела — картами.
 */
import { OFFSET_KEY, savedDateOffset } from './savedViewDate'
import { SECTION_KEY, type ViewSection } from './savedViewQuery'

export interface ViewFrame {
  lat_min: number
  lat_max: number
  lon_min: number
  lon_max: number
}

export function saveViewState(
  section: ViewSection,
  state: Record<string, unknown>,
  frame: ViewFrame | null | undefined,
  today: string,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...state, [SECTION_KEY]: section }
  if (frame) {
    out.lat = (frame.lat_min + frame.lat_max) / 2
    out.lng = (frame.lon_min + frame.lon_max) / 2
  }
  const offset = savedDateOffset(
    typeof state.date === 'string' ? state.date : null, today)
  // Смещения нет, когда даты нет вовсе. Ставить ноль было бы неправдой: «дата
  // не выбрана» и «сегодняшняя дата» — разные вещи.
  if (offset !== null) out[OFFSET_KEY] = offset
  return out
}
